var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLampIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 5.25833V1.25H7.49967V5.25833C6.00801 6.125 4.99967 7.73333 4.99967 9.58333C4.99967 12.3417 7.24134 14.5833 9.99967 14.5833C12.758 14.5833 14.9997 12.3417 14.9997 9.58333C14.9997 7.73333 13.9913 6.125 12.4997 5.25833ZM0.833008 8.75H3.33301V10.4167H0.833008V8.75ZM2.95801 15.45L4.13301 16.625L5.62467 15.125L4.44967 13.95L2.95801 15.45ZM9.16634 18.7083H10.833V16.25H9.16634V18.7083ZM16.6663 10.4167V8.75H19.1663V10.4167H16.6663ZM14.3663 15.1333L15.858 16.6333L17.033 15.4583L15.533 13.9667L14.3663 15.1333Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampIcon);
export default __webpack_public_path__ + "static/media/lamp-icon.c2187be4028005bf750c89eb57d775f8.svg";
export { ForwardRef as ReactComponent };